module.exports = __webpack_public_path__ + "img/Screwdriver.af074e17.png";